import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { isApiSuccess } from '@/api/shared.types.ts';
import {
  getVoucherStatistics,
  VoucherStatistics,
} from '@/api/voucher/voucher.actions';
import { useAsync } from '@/hooks/global/useAsync';
import { useAuthStore } from '@/stores/useAuthStore';

type UseVoucherStatisticsReturn = {
  statistics: VoucherStatistics;
  isLoading: boolean;
  refetch: () => Promise<void>;
};

export const useVoucherStatistics = (): UseVoucherStatisticsReturn => {
  const [statistics, setStatistics] = useState<VoucherStatistics>({
    purchased: 0,
    active: 0,
    redeemed: 0,
  });

  const { isInitialized, isLoggedIn } = useAuthStore();
  const { run, isLoading } = useAsync();

  const fetchStatistics = async (): Promise<void> => {
    const response = await run(() => getVoucherStatistics());

    if (!isApiSuccess(response)) {
      toast.error(response.error.message);
      return;
    }

    setStatistics(response.content.statistics);
  };

  useEffect(() => {
    if (isInitialized && isLoggedIn) {
      fetchStatistics();
    }
  }, [isInitialized, isLoggedIn]);

  return {
    statistics,
    isLoading,
    refetch: fetchStatistics,
  };
};
